export default {
  'pages.setting.user.title': 'User Management',
  'pages.setting.user.subtitle':
    'Manage system user accounts, roles and permissions',
  'pages.setting.user.searchPlaceholder': 'Search username, name or email',
  'pages.setting.user.export': 'Export',
  'pages.setting.user.exportFileName': 'User Data',
  // Table columns
  'pages.setting.user.column.id': 'User ID',
  'pages.setting.user.column.userName': 'Username',
  'pages.setting.user.column.nickName': 'Full Name',
  'pages.setting.user.column.email': 'Email',
  'pages.setting.user.column.phone': 'Phone',
  'pages.setting.user.column.role': 'Role',
  'pages.setting.user.column.department': 'Department',
  'pages.setting.user.column.status': 'Status',
  'pages.setting.user.column.lastLoginTime': 'Last Login Time',
  'pages.setting.user.column.operation': 'Operation',
  // Status
  'pages.setting.user.status.enabled': 'Enabled',
  'pages.setting.user.status.disabled': 'Disabled',
  // Actions
  'pages.setting.user.resetPassword': 'Reset Password',
  'pages.setting.user.resetPasswordConfirm': 'Confirm password reset?',
  'pages.setting.user.add': 'Add User',
  'pages.setting.user.edit': 'Edit',
  // Modal titles
  'pages.setting.user.modal.addTitle': 'Add User',
  'pages.setting.user.modal.editTitle': 'Edit User',
  // Form
  'pages.setting.user.form.userName': 'Username',
  'pages.setting.user.form.userNamePlaceholder': 'Please enter username',
  'pages.setting.user.form.userNameRequired': 'Please enter username',
  'pages.setting.user.form.userNameLength': 'Username must be 4-20 characters',
  'pages.setting.user.form.userNamePattern':
    'Username can only contain letters, numbers and underscores',
  'pages.setting.user.form.nickName': 'Full Name',
  'pages.setting.user.form.nickNamePlaceholder': 'Please enter full name',
  'pages.setting.user.form.nickNameRequired': 'Please enter full name',
  'pages.setting.user.form.email': 'Email',
  'pages.setting.user.form.emailPlaceholder': 'Please enter email address',
  'pages.setting.user.form.emailRequired': 'Please enter email address',
  'pages.setting.user.form.emailInvalid': 'Please enter a valid email address',
  'pages.setting.user.form.phone': 'Phone',
  'pages.setting.user.form.phonePlaceholder': 'Please enter phone number',
  'pages.setting.user.form.phoneRequired': 'Please enter phone number',
  'pages.setting.user.form.phoneInvalid':
    'Please enter a valid Philippines phone number',
  'pages.setting.user.form.department': 'Department',
  'pages.setting.user.form.departmentPlaceholder': 'Please select department',
  'pages.setting.user.form.departmentRequired': 'Please select department',
  'pages.setting.user.form.sex': 'Gender',
  'pages.setting.user.form.sexPlaceholder': 'Please select gender',
  'pages.setting.user.form.sexMale': 'Male',
  'pages.setting.user.form.sexFemale': 'Female',
  'pages.setting.user.form.role': 'Role',
  'pages.setting.user.form.rolePlaceholder': 'Please select role',
  'pages.setting.user.form.roleRequired': 'Please select role',
  'pages.setting.user.form.status': 'Status',
  'pages.setting.user.form.password': 'Password',
  'pages.setting.user.form.passwordPlaceholder':
    'Enter 6-20 characters with letters and numbers',
  'pages.setting.user.form.passwordRequired': 'Please enter password',
  'pages.setting.user.form.passwordPattern':
    'Password must be 6-20 characters with both letters and numbers',
  'pages.setting.user.form.remark': 'Remark',
  'pages.setting.user.form.remarkPlaceholder': 'Please enter remark',
  // Messages
  'pages.setting.user.message.updateStatusSuccess':
    'Status updated successfully',
  'pages.setting.user.message.resetSuccess': 'Password reset successfully',
  'pages.setting.user.message.deleteSuccess': 'Deleted successfully',
  'pages.setting.user.message.selectAtLeastOne':
    'Please select at least one item',
  'pages.setting.user.message.addSuccess': 'Added successfully',
  'pages.setting.user.message.editSuccess': 'Updated successfully',
  'pages.setting.user.message.exportCount': 'Export {count} user(s)',
  'pages.setting.user.message.exportSuccess': 'Export successful',
  'pages.setting.user.message.exportFailed': 'Export failed, please retry',
};
